// libs
import React, { memo } from 'react';
import { styled } from '@nykaa/ui-components';
import { connect } from 'react-redux';

// helpers
import { BASE_GUTTER_SPACE, COLORS, DWEB_ICON_BREAKPOINT } from 'shared/styles/base';
import { LINKS } from 'shared/components/MyAccount/constants';
import { isLoggedIn as _isLoggedIn } from 'shared/store/app/selectors';

// contexts
import { useAuthModalWrapperContext } from 'shared/components/AuthModal/AuthModalWrapperContext';

export const WishlistContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${BASE_GUTTER_SPACE * 3}px;
  text-transform: capitalize;
  color: ${COLORS.BLACK_100};
  cursor: pointer;
  flex-shrink: 1;
`;

export const TextContainer = styled.div`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media screen and (max-width: ${DWEB_ICON_BREAKPOINT}) {
    display: none;
  }
`;

export const Icon = styled.i`
  height: 24px;
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  font-size: 20px;
`;

interface IWishlistProps {
  isLoggedIn: boolean;
}

const LABEL = 'Wishlist';

function WishList({ isLoggedIn }: IWishlistProps) {
  const { passiveShowAuthModal } = useAuthModalWrapperContext();
  const handleClick = () => {
    if (isLoggedIn === false) {
      passiveShowAuthModal(LINKS.MY_WISHLIST);
      return;
    }
    window.open(LINKS.MY_WISHLIST);
  };

  return (
    <WishlistContainer onClick={handleClick}>
      <Icon className="icon-heart" />
      <TextContainer>{LABEL}</TextContainer>
    </WishlistContainer>
  );
}

const mapStateToProps = (state: any) => {
  return {
    isLoggedIn: _isLoggedIn(state),
  };
};

export default connect(mapStateToProps)(memo(WishList));
